// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceSubscription {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d;
        this.status = model.status;
        this.seatLimit = model.seatLimit;
        this.seats = model.seats;
        this.product = model.product;
        this.planInterval = model.planInterval;
        this.planPriceId = model.planPriceId;
        this.currentPeriodStart = model.currentPeriodStart
            ? new Date(model.currentPeriodStart)
            : null;
        this.currentPeriodEnd = model.currentPeriodEnd
            ? new Date(model.currentPeriodEnd)
            : null;
        this.stripeCustomerId = (_a = model.stripeCustomerId) !== null && _a !== void 0 ? _a : null;
        this.stripeSubscriptionId = (_b = model.stripeSubscriptionId) !== null && _b !== void 0 ? _b : null;
        // @ts-expect-error TS(2322): Type '{ last4: string | undefined; expiryMonth: st... Remove this comment to see the full error message
        this.card = model.card
            ? {
                last4: model.card.last4,
                expiryMonth: model.card.expiryMonth,
                expiryYear: model.card.expiryYear,
                brand: (_c = model.card.brand) !== null && _c !== void 0 ? _c : null,
            }
            : null;
        this.amount = model.amount;
        this.stripeProductDescription = model.stripeProductDescription;
        this.subscriptionStatusUpdatedAt = model.subscriptionStatusUpdatedAt
            ? new Date(model.subscriptionStatusUpdatedAt)
            : null;
        this.legacyVersion = (_d = model.legacyVersion) !== null && _d !== void 0 ? _d : null;
        this.isPricePerCreator = model.isPricePerCreator;
        this.stripeProductFeatures = model.stripeProductFeatures;
        this.stripeProductAdditionalFeatures = model.stripeProductAdditionalFeatures;
        this.featuresSummary = model.featuresSummary;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toRemote() {
        var _a, _b;
        // Implement according to your needs
        return {
            status: this.status,
            seatLimit: this.seatLimit,
            seats: this.seats,
            product: this.product,
            planInterval: this.planInterval,
            planPriceId: this.planPriceId,
            stripeCustomerId: (_a = this.stripeCustomerId) !== null && _a !== void 0 ? _a : undefined,
            stripeSubscriptionId: (_b = this.stripeSubscriptionId) !== null && _b !== void 0 ? _b : undefined,
            // @ts-expect-error TS(2322): Type '{ last4: string | null; expiryMonth: string ... Remove this comment to see the full error message
            card: this.card,
            currentPeriodStart: this.currentPeriodStart
                ? this.currentPeriodStart.toISOString()
                : undefined,
            currentPeriodEnd: this.currentPeriodEnd
                ? this.currentPeriodEnd.toISOString()
                : undefined,
            amount: this.amount,
            stripeProductDescription: this.stripeProductDescription,
            subscriptionStatusUpdatedAt: 
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            this.subscriptionStatusUpdatedAt.toISOString(),
            // @ts-expect-error TS(2322): Type 'number | null' is not assignable to type 'nu... Remove this comment to see the full error message
            legacyVersion: this.legacyVersion,
            isPricePerCreator: this.isPricePerCreator,
            stripeProductFeatures: this.stripeProductFeatures,
            stripeProductAdditionalFeatures: this.stripeProductAdditionalFeatures,
            featuresSummary: this.featuresSummary,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceSubscription(model);
    }
}
